module.exports = {"140603100":"井坪镇","140603101":"凤凰城镇","140603200":"白堂乡","140603201":"陶村乡","140603202":"下水头乡","140603203":"双碾乡","140603204":"阻虎乡","140603205":"高石庄乡","140603206":"西水界乡","140603207":"下面高乡","140603208":"下木角乡","140603209":"向阳堡乡","140603210":"榆岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140603.json
// module id = 276
// module chunks = 0